import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const getUserAddresses = async () => {
  try {
    const response = await client.get("/users/addresses");
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const saveUserAddress = async (newAddress) => {
  try {
    await client.post("/users/address", newAddress);
  } catch (err) {
    throw err;
  }
};

export const updateUserAddress = async (updatedAddress) => {
  const addressId = updatedAddress.addressId;
  const address = updatedAddress.address;
  try {
    await client.put(`/users/address/${addressId}`, address);
  } catch (err) {
    throw err;
  }
};

export const deleteUserAddress = async (addressId) => {
  try {
    await client.delete(`/users/address/${addressId}`);
  } catch (err) {
    throw err;
  }
};

// --- Dashboard Key Stats ---
export const getKeyStats = async () => {
  try {
    const response = await client.get("/users/key-stats");
    return response.data; // { shipmentsSent, upcomingDeliveries, lastDelivered }
  } catch (err) {
    throw err;
  }
};
